import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators/custom-element.js';
import { property } from 'lit/decorators/property.js';
import { state } from 'lit/decorators/state.js';
import { classMap } from 'lit/directives/class-map.js';

import styles from './rhpt-location-show-hide.css';

/**
 * Location Show Hide
 * @slot - Place element content here
 */
@customElement('rhpt-location-show-hide')
export class RhptLocationShowHide extends LitElement {
  static readonly styles = [styles];

  @property({ attribute: 'query-params'})
  protected queryParams?: string;

  @property()
  protected behavior: 'show' | 'hide' = 'show';

  @state()
  protected active = false;

  protected updated(_changedProperties: Map<PropertyKey, unknown>): void {
    if (_changedProperties.has('queryParams')) {
      this._popStateHandler();
    }
  }

  async connectedCallback() {
    super.connectedCallback();
    this._popStateHandler();
    // @todo: this is terrible.
    // patch pushState to trigger event listener for locationchange
    (function(history, scope){
      var pushState = history.pushState;
      history.pushState = function(state) {
        // ... whatever else you want to do
        // maybe call onhashchange e.handler
        // @ts-ignore
        pushState.apply(history, arguments);
        scope._popStateHandler();
        return;
      };
    })(window.history, this);
    window.addEventListener('popstate', this._popStateHandler)
  }

  _popStateHandler() {
    let search = new URLSearchParams(window.location.search)
    this.active = !!Array.from(new URLSearchParams(this.queryParams))
      // pull out all of the query param values into their own array
      .flatMap(([key, value]) => value.split('|').map(i => [key, i]))
      // find out if each query param is in the window.location.search
      .map(([key, value]) => {
        // If the user specified 'undefined', then that means they want
        // to check if the param is either not present or set to an empty
        // string
        // @example query-params="products=featured|undefined"
        if (value === 'undefined') {
          return !search.get(key) || search.get(key) === '';
        }
        else {
          return search.get(key) === value;
        }
      })
      // remove any false values
      .find(i => i);
  }

  render() {
    const active = this.active && this.behavior !== 'hide';
    return html`
      <div part="base" class=${classMap({ active })}>
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rhpt-location-show-hide': RhptLocationShowHide;
  }
}
